<div class="password-strength">
  <p class="strength-title">{{ 'PASSWORD_STRENGTH.TITLE' | translate }}</p>
  <ul class="rules-list">
    <li *ngFor="let rule of rules" [class.valid]="isValid(rule)">
      <span class="indicator">
        <img *ngIf="isValid(rule)" class="checkmark-icon" [src]="isDark() ? 'assets/icons/checkmark-dark.svg' : 'assets/icons/checkmark.svg'" alt="" />
        <span *ngIf="!isValid(rule)" class="bullet">&bull;</span>
      </span>
      {{ rule.key | translate }}
    </li>
  </ul>
</div>
